import React from 'react';
import { motion } from 'framer-motion';
import './about-disgenet.css';

export interface FeatureCardProps {
  title: string;
  points: string[];
  badgeText: string;
  icon: React.ReactNode;
  index?: number;
}

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.1,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.08,
      delayChildren: 0.15,
    } as const,
  }),
};

const pointVariants = {
  hidden: { opacity: 0, x: -12 },
  visible: { opacity: 1, x: 0 },
};

export function FeatureCard({ title, points, badgeText, icon, index = 0 }: FeatureCardProps) {
  return (
    <motion.article
      className="about-feature-card"
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-60px' }}
      custom={index}
      whileHover={{
        y: -4,
        transition: { duration: 0.3, ease: 'easeOut' },
      }}
    >
      <div className="flex items-center">
        <div className="about-feature-card__icon" aria-hidden>
          {icon}
        </div>
        <h3 className="about-feature-card__title">{title}</h3>
      </div>
      <ul className="about-feature-card__list">
        {points.map((point, i) => (
          <motion.li key={i} variants={pointVariants} className="about-feature-card__point">
            {point}
          </motion.li>
        ))}
      </ul>
      <div className="about-feature-card__badge">
        <span>{badgeText}</span>
      </div>
    </motion.article>
  );
}
